module.exports = __webpack_public_path__ + "static/media/feitianB1.cb034fbd.png";